module.exports = __webpack_public_path__ + "static/media/photo219.398bbcc7.jpg";